import axios from '@axios'

const route = 'cash'

export default {
  namespaced: true,
  state: {
    cash: null,

  },
  getters: {
    getCash(state) {
      return state.cash
    },

  },
  mutations: {
    setCash(state, cash) {
      state.cash = cash
    },

  },
  actions: {
    loadCashs(context, payload) {
      return axios.post(route, payload)
    },
    getCurrentCash(context) {
      return axios.get(`${route}/current_cash`)
    },
    getExtractCash() {
      return axios.get(`${route}/extract_cash`)
    },

    getExtractCashId(context, cashId) {
      return axios.get(`${route}/extract_cash?cash_id=${cashId}`)
    },

    // carraga o resumo do caixa
    getCashSummary(context, cashId) {
      return axios.get(`${route}/cash_summary/${cashId}`)
    },

    openCash(context, initialCash) {
      return axios.post(`${route}/open`, {
        initial_cash: initialCash,
      })
    },

    closeCash(context) {
      return axios.post(`${route}/close`)
    },

    openLastCash(context) {
      return axios.post(`${route}/open_last`)
    },

    getOldCash(context, lastTenCash) {
      return axios.get(`${route}/old_cashs/${lastTenCash}`)
    },

    reopenOldCash(context, cashId) {
      return axios.post(`${route}/reopen_old_cashs/${cashId}`)
    },

    registerOldCash(context, cash) {
      return axios.post(`${route}/register_old_cash`, cash)
    },

    // registrar um deposito no caixa
    deposit(context, deposit) {
      return axios.post(`${route}/store_deposit`, deposit)
    },

    // registrar saque
    withdrawal(context, withdrawal) {
      return axios.post(`${route}/store_withdrawal`, withdrawal)
    },
  },
}
